<template>
  <b-container>
    <b-row  style="margin: 0;right: 0; min-height: calc(100vh - 80px)">
      <b-row>
        <b-col md="8" xs="12">
          <b-img fluid src="../assets/images/eyds_kamp.png"/>
        </b-col>
        <b-col md="4" xs="12" style="padding-bottom: 30px">
          <div class="header text-center">
            <h1 class="mor">Ankara Dil Akademisi Kamp Programları</h1>
            <h2>Elektronik YDS 'ye eksiksiz hazırlanın</h2>
            <p class="mor"> Ankara Dil Akademisi'nin soru çözüm kampları ile sınavlar artık daha kolay</p>
            <p class="mor"> Hem E-YDS hem de YDS için  harika bir çalışma sistemi</p>
            <!--<p class="mor"> Sistemi daha iyi tanımanız için <strong>ücretsiz</strong> sınavımızı çözebilirsiniz.</p>-->
            <b-button style="color:white" href="https://www.ankaradil.com/59-yds-soru-cozum-kampi" variant="success">Hemen İnceleyin</b-button>
          </div>
        </b-col>
        <b-container>
          <h3>10 GÜNLÜK YDS SORU ÇÖZÜM KAMPI</h3>
          <p>YDS ÖNCESİ 10 GÜNLÜK SORU ÇÖZÜM MARATONUNA KATILIN. SINAVI ŞANSA BIRAKMAYIN.</p>
          <p>Yapılan dersler YDS’de karşınıza çıkabilecek tüm soru tiplerini kapsar. Tijen Hoca ve Ümit Hoca, kamp programına özel hazırladıkları özgün soruları çözerler.  </p>
        </b-container>
        <b-container>
          <h3>SINAV ÖNCESİ YOĞUN BİR ŞEKİLDE SORU ÇÖZME!</h3>
          <p>Sınav öncesi yoğun bir şekilde detaylı soru çözümüne maruz kalan adaylar sınava tamamen hazır hale gelecekler. Kayıttan program satın alındığında yapılan uzaktan canlı derslerin kayıttan videolarına erişim sağlanmaktadır.</p>
        </b-container>
      </b-row>
    </b-row>
    <b-container class="footer text-center"><a href="https://www.ankaradil.com" target="_blank"> Ankara Dil Akademisi </a> için <a href="http://code4edu.com" target="_blank"> code4edu.com  </a> tarafından hazırlanmıştır.</b-container>
  </b-container>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.header{
  margin-top: 25%;
}
.mor{
  color:#7c7cb0
}
.footer {
  /*position: absolute;*/
  width: 100%;
  height: 80px
}
.content{

}
</style>



// WEBPACK FOOTER //
// src/components/KampProgramlari.vue